/**
 * A number typed into a field (card t_8842b1fe).
 *
 * The rule this file exists to keep: **an emptied field is not a ZERO**.
 * `Number('')` is 0, so every save path that read an input raw wrote 0 — and a
 * widget whose width became 0 is a widget nobody can see or click. The owner,
 * 2026-10-13: *"i edited widget and set it's width to 0, by accident.. i deleted
 * all text in field. and that when it broke.. it got removed from the
 * configuration"*.
 *
 * An EMPTY (or unparseable) field therefore keeps the value it already held —
 * "no change" is what an empty box means — and a typed value is clamped into the
 * range the field itself declares (`min`/`max`), which is the same shape the
 * parser applies on read (`utils/bimDeviceModel.readParamNumber`).
 */

/** The range one field declares. An end that is missing or junk does not clamp. */
export interface NumberFieldLimits {
  min?: number;
  max?: number;
}

export function readNumberField(raw: unknown, current: number, limits: NumberFieldLimits = {}): number {
  const text = typeof raw === 'string' ? raw.trim() : raw === null || raw === undefined ? '' : String(raw);
  const parsed = text === '' ? Number.NaN : Number(text);
  return clampToRange(Number.isFinite(parsed) ? parsed : current, limits);
}

/** `value` inside its own range. Junk in the value itself reads as 0. */
export function clampToRange(value: number, limits: NumberFieldLimits = {}): number {
  const min = typeof limits.min === 'number' && Number.isFinite(limits.min) ? limits.min : -Infinity;
  const max = typeof limits.max === 'number' && Number.isFinite(limits.max) ? limits.max : Infinity;
  const finite = Number.isFinite(value) ? value : 0;
  return Math.min(max, Math.max(min, finite));
}

/**
 * A stored SIZE, read as the value a widget can actually be (card t_8842b1fe): a
 * 0 or a negative reads as the default. A zero-sized widget is an invisible and
 * unclickable one, and one reached the hub — see the header — so a size on its
 * way to a layout or an editor never reads as 0.
 */
export function readSize(value: unknown, fallback: number): number {
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}
